"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsError = exports.disable = exports.enable = exports.flushEvents = exports.configureAutoTrack = exports.identifyUser = exports.record = void 0;
// This entry point intentionally re-exports the deprecated Pinpoint provider
// APIs as the default Analytics surface. Removing them would be a breaking
// change; instead each is wrapped to emit a one-time runtime deprecation
// warning. The deprecated imports below are therefore expected.
/* eslint-disable import/no-deprecated */
const pinpoint_1 = require("./providers/pinpoint");
const utils_1 = require("./utils");
/**
 * @deprecated The default (Amazon Pinpoint) Analytics APIs are deprecated. AWS will end support for
 * Amazon Pinpoint on October 30, 2026. Migrate to a supported provider by importing from its sub-path
 * export instead — for example `aws-amplify/analytics/kinesis`, `aws-amplify/analytics/kinesis-firehose`,
 * or `aws-amplify/analytics/personalize`.
 */
exports.record = (0, utils_1.deprecatePinpoint)(pinpoint_1.record);
/**
 * @deprecated The default (Amazon Pinpoint) Analytics APIs are deprecated. AWS will end support for
 * Amazon Pinpoint on October 30, 2026. Migrate to a supported provider by importing from its sub-path
 * export instead — for example `aws-amplify/analytics/kinesis`, `aws-amplify/analytics/kinesis-firehose`,
 * or `aws-amplify/analytics/personalize`.
 */
exports.identifyUser = (0, utils_1.deprecatePinpoint)(pinpoint_1.identifyUser);
/**
 * @deprecated The default (Amazon Pinpoint) Analytics APIs are deprecated. AWS will end support for
 * Amazon Pinpoint on October 30, 2026. Migrate to a supported provider by importing from its sub-path
 * export instead — for example `aws-amplify/analytics/kinesis`, `aws-amplify/analytics/kinesis-firehose`,
 * or `aws-amplify/analytics/personalize`.
 */
exports.configureAutoTrack = (0, utils_1.deprecatePinpoint)(pinpoint_1.configureAutoTrack);
/**
 * @deprecated The default (Amazon Pinpoint) Analytics APIs are deprecated. AWS will end support for
 * Amazon Pinpoint on October 30, 2026. Migrate to a supported provider by importing from its sub-path
 * export instead — for example `aws-amplify/analytics/kinesis`, `aws-amplify/analytics/kinesis-firehose`,
 * or `aws-amplify/analytics/personalize`.
 */
exports.flushEvents = (0, utils_1.deprecatePinpoint)(pinpoint_1.flushEvents);
var apis_1 = require("./apis");
Object.defineProperty(exports, "enable", { enumerable: true, get: function () { return apis_1.enable; } });
Object.defineProperty(exports, "disable", { enumerable: true, get: function () { return apis_1.disable; } });
var errors_1 = require("./errors");
Object.defineProperty(exports, "AnalyticsError", { enumerable: true, get: function () { return errors_1.AnalyticsError; } });
